// Google Maps API Configuration. The script is loaded on demand by
// initializeGoogleMaps() (e.g. when the location picker opens), never on page load.

// Use environment variable for Google Maps API key
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const initializeGoogleMaps = () => {
  // Don't try to load if no API key is provided
  if (!GOOGLE_MAPS_API_KEY) {
    console.warn(
      'Google Maps API key not found. Please add REACT_APP_GOOGLE_MAPS_API_KEY to your environment variables.'
    );
    return false;
  }

  if (typeof window !== 'undefined' && !window.google) {
    // Check if script is already being loaded
    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
      return true;
    }

    // Try to load the script
    const loadScript = () => {
      const script = document.createElement('script');

      // Use callback approach for better initialization
      const callbackName = 'initGoogleMaps_' + Date.now();
      window[callbackName] = () => {
        // Check if required APIs are available
        if (window.google && window.google.maps) {
          // Check for Places API
          if (window.google.maps.places) {
          } else {
            console.warn(
              'Google Places API not loaded. Make sure Places API is enabled in Google Cloud Console.'
            );
          }

          // Check for Geocoding API
          if (window.google.maps.Geocoder) {
          } else {
            console.warn(
              'Google Geocoding API not loaded. Make sure Geocoding API is enabled in Google Cloud Console.'
            );
          }
        }

        delete window[callbackName];
      };

      // Load all necessary libraries
      const scriptUrl = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places,geometry,marker&loading=async&callback=${callbackName}`;
      script.src = scriptUrl;

      script.async = true;
      script.defer = true;
      script.type = 'text/javascript';

      script.onload = () => {};

      script.onerror = (error) => {
        console.error('Failed to load Google Maps API:', error);
        console.error('Script src:', script.src);

        // Try alternative loading method

        const altScript = document.createElement('script');
        altScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places,geometry,marker&loading=async`;
        altScript.async = true;
        altScript.defer = true;

        altScript.onload = () => {};

        altScript.onerror = (altError) => {
          console.error('Alternative loading method also failed:', altError);
        };

        document.head.appendChild(altScript);
      };

      // Add error event listener
      script.addEventListener('error', (error) => {
        console.error('Script error event:', error);
      });

      try {
        document.head.appendChild(script);

        return true;
      } catch (error) {
        console.error('Error adding script to DOM:', error);
        return false;
      }
    };

    return loadScript();
  }

  return false;
};

export const isGoogleMapsLoaded = () => {
  return (
    typeof window !== 'undefined' &&
    window.google &&
    window.google.maps &&
    window.google.maps.places
  );
};

export const canLoadGoogleMaps = () => {
  return !!GOOGLE_MAPS_API_KEY;
};
